import * as React from "react";
import BDMPerformance from "./bdmPerformance";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Box,
} from "@mui/material";
import { BDM_PERFORMANCE_SUMMARY } from "../../constants";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";







































































































import { Doughnut, Pie } from "react-chartjs-2";
import moment from "moment/moment";
import dayjs from "dayjs";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useTheme } from "@emotion/react";
import { format } from "date-fns";
import KpiDetailsComponent from "./kpiDetailsComponent";
// Register the necessary chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

function BdmDashboardComponent() {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);

  const theme = useTheme();

  const fetchPerformanceSummary = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BDM_PERFORMANCE_SUMMARY}?startDate=${startDate}&endDate=${endDate}&bdmId=${localStorage.getItem(
          "username"
        )}`
      );
      setReportData(response.data.data);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false); // Set loading to false when data fetching finishes (whether success or failure)
    }
  };

  useEffect(() => {
    fetchPerformanceSummary(startDate, endDate);
  }, []);

 
  const [filterShow, setFilterShow] = useState(false);
  const [startDate, setStartDate] = useState(
    dayjs().subtract(1, "day").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dayjs().subtract(1, "day").format("YYYY-MM-DD")
  );

  const handleApply = () => {
    fetchPerformanceSummary(startDate, endDate); // Fetch data for the selected date range
    setFilterShow(false);
    localStorage.setItem("startDate", startDate); // Save selected dates to localStorage
    localStorage.setItem("endDate", endDate);
  };

  const handleClear = () => {
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
    setStartDate(yesterday); // Reset to yesterday
    setEndDate(yesterday); // Reset to yesterday
    fetchPerformanceSummary(yesterday, yesterday);
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    setFilterShow(false);
  };

  const [selectedBDM, setSelectedBDM] = useState(0);
  const [activeTab, setActiveTab] = useState("overview");

  // Colors for pie chart
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#FF4560",
    "#00BFFF",
    "#FFD700",
    "#8A2BE2",
  ];

  let totalCompleted = 0;
  let totalTarget = 0;
  let completionRate = 0;
  let actionPieData = [];
  let actionProgress = [];
  let data = [];

  // Ensure that reportData.actions is defined and is an array before using reduce
  if (reportData && reportData[0] && Array.isArray(reportData[0]?.actions)) {
    totalCompleted = reportData[0]?.actions.reduce(
      (sum, action) => sum + action.done,
      0
    );
    totalTarget = reportData[0]?.actions.reduce(
      (sum, action) => sum + action.target,
      0
    );
    completionRate = totalTarget
      ? Math.round((totalCompleted / totalTarget) * 100)
      : 0;

    const actionPieData = reportData[0]?.actions.map((action) => ({
      name: action.type,
      value: action.done,
    }));

    // Prepare data for chart.js pie chart
    data = {
      labels: actionPieData.map((entry) => entry.name),
      datasets: [
        {
          data: actionPieData.map((entry) => entry.value),
          backgroundColor: COLORS,
          hoverBackgroundColor: COLORS,
        },
      ],
    };

    actionProgress = reportData[0]?.actions.map((action) => {
      const percentage =
        action.target > 0
          ? Math.min(Math.round((action.done / action.target) * 100), 100)
          : 0;
      return {
        ...action,
        percentage,
      };
    });
  } else {
    console.warn(
      "reportData[0] or reportData[0].actions is not an array or is undefined."
    );
  }

//   const formatTime = (timestamp) => {
//   if (!timestamp) return "--:--";

//   // Expected format: "16-06-2025 08:21:09"
//   const [datePart, timePart] = timestamp.split(" ");
//   const [day, month, year] = datePart.split("-");
  
//   const isoString = `${year}-${month}-${day}T${timePart}`;
//   const date = new Date(isoString);

//   if (isNaN(date)) return "--:--"; // Fallback for invalid dates

//   return date.toLocaleTimeString([], {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

const formatTime = (timestamp) => {
  if (!timestamp) return "--:--";

  const date = new Date(timestamp);

  if (isNaN(date)) return "--:--";

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

 
  const attendanceInTime =
JSON.parse(localStorage.getItem("userData") || "{}")?.todayAttendance
      ?.inTime ??
      (JSON.parse(localStorage.getItem("attendance") || "{}")?.inTime) ??
    null;

    console.log("Attendance In Time:", attendanceInTime);
    

  const attendanceOutTime =
    JSON.parse(localStorage.getItem("userData") || "{}")?.todayAttendance
      ?.outTime ??
    JSON.parse(localStorage.getItem("attendance") || "{}")?.outTime ??
    null;

  


  return (
    <>
      <div className="bg-gray-50 min-h-screen pb-6">
        {/* Top fixed header */}
        <div className="bg-white sticky top-0 shadow-sm z-10">
          <div className="p-4">
            <div className="flex justify-between items-center gap-2">
              {/* Attendance In Time */}
              <div className="flex flex-col items-center bg-blue-50 p-4 rounded-lg shadow-md">
                <span className="text-sm font-medium text-gray-700">
                  Attendance In
                </span>
                <p className="mt-2 text-xl font-semibold text-blue-600">
                  {attendanceInTime ? formatTime(attendanceInTime) : "--:--"}{" "}
                  {/* Format the time */}
                </p>
              </div>

              {/* Attendance Out Time */}
              <div className="flex flex-col items-center bg-green-50 p-4 rounded-lg shadow-md">
                <span className="text-sm font-medium text-gray-700">
                  Attendance Out
                </span>
                <p className="mt-2 text-xl font-semibold text-green-600">
                  {attendanceOutTime ?formatTime(attendanceOutTime) : "--:--"}
                </p>
              </div>
            </div>
          </div>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 1, // Space between items
              position: "relative", // Make sure the filter UI stays within this context
              
            }}
          >
            {/* Filter Icon */}
            <div>
              <IconButton
                onClick={() => setFilterShow((prev) => !prev)}
                style={buttonStyle}
                onMouseEnter={(e) => hoverEffects(e, true)}
                onMouseLeave={(e) => hoverEffects(e, false)}
              >
                <FilterListIcon />
              </IconButton>
            </div>

            {filterShow && (
              <Box
                sx={{
                  position: "absolute", // This will overlay the filter UI beside the icon
                  top: "100%", // Position below the icon
                  right: 0, // Align to the right of the container
                  backgroundColor: "#f0f4f8",
                  padding: 1,
                  borderRadius: 2,
                  boxShadow: 3,
                  width: "auto", // Width adjusts according to content
                  maxWidth: "300px", // Set a max width for responsiveness
                  zIndex: 10, // Ensure the filter UI is above other elements
                  display: "flex",
                  flexDirection: "column",
                  gap: 2, // Space between the elements
                  [theme.breakpoints.down("lg")]: {
                    width: "100%", // On smaller screens, use 90% of the available width
                    right: "10%", // Ensure it's not touching the edge of the screen
                  },
                }}
              >
                <Grid container spacing={2}>
                  {/* Start Date Picker */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Start Date"
                      type="date"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </Grid>

                  {/* End Date Picker */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="End Date"
                      type="date"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </Grid>

                  {/* Action Buttons */}
                  <Grid item xs={12} sm={3}>
                    <Box sx={{ display: "flex" }}>
                      <Button
                        onClick={handleClear}
                        variant="outlined"
                        color="secondary"
                        sx={{ marginRight: 2 }}
                      >
                        Clear
                      </Button>
                      <Button
                        onClick={handleApply}
                        variant="contained"
                        color="primary"
                      >
                        Apply
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Tab navigation */}
          <div className="flex mt-2 border-b">
            <button
              className={`flex-1 py-2 text-sm font-medium ${
                activeTab === "overview"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600"
              }`}
              onClick={() => setActiveTab("overview")}
            >
              Overview
            </button>
            <button
              className={`flex-1 py-2 text-sm font-medium ${
                activeTab === "actions"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600"
              }`}
              onClick={() => setActiveTab("actions")}
            >
              Actions
            </button>
            <button
              className={`flex-1 py-2 text-sm font-medium ${
                activeTab === "kpi"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600"
              }`}
              onClick={() => setActiveTab("kpi")}
            >
              KPI
            </button>
          </div>
        </div>

        {/* Loading Spinner */}
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <CircularProgress />
          </div>
        ) : (
          <div>
            <div className="px-2 pt-3">
              {/* Overview Tab */}
              {activeTab === "overview" && (
                <div>
                  {/* Performance summary card */}
                  <div className="bg-white rounded-lg shadow p-4 mb-4">
                    <div className="flex justify-between items-center mb-4">
                      <div>
                        <h2 className="text-lg font-semibold">
                          {reportData[0].name}
                        </h2>
                        <p className="text-gray-500 text-sm">
                          Performance Summary
                        </p>
                      </div>
                      <div
                        className="w-16 h-16 rounded-full flex items-center justify-center border-4"
                        style={{
                          borderColor:
                            completionRate >= 90
                              ? "#10B981"
                              : completionRate >= 70
                              ? "#3B82F6"
                              : completionRate >= 50
                              ? "#F59E0B"
                              : "#EF4444",
                        }}
                      >
                        <span className="text-lg font-bold">
                          {completionRate}%
                        </span>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <div className="bg-blue-50 p-3 rounded-lg">
                        <p className="text-xs text-gray-500">Completed</p>
                        <p className="text-xl font-bold">{totalCompleted}</p>
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-xs text-gray-500">Target</p>
                        <p className="text-xl font-bold">{totalTarget}</p>
                      </div>
                    </div>
                  </div>

                  {/* Action breakdown pie chart */}
                  <div className="bg-white rounded-lg shadow p-4 mb-4">
                    <h3 className="text-md font-semibold mb-3">
                      Action Distribution
                    </h3>
                    <div
                      className="w-full h-72"
                      style={{ justifyItems: "center" }}
                    >
                      <Doughnut data={data} />
                    </div>
                  </div>

                  {/* Quick stats cards */}
                  <div className="bg-white rounded-lg shadow p-4">
                    <h3 className="text-md font-semibold mb-3">Quick Stats</h3>

                    <div className="space-y-3">
                      {actionProgress.map((action, index) => (
                        <div
                          key={action.type}
                          className="bg-gray-50 p-3 rounded-lg"
                        >
                          <div className="flex justify-between mb-1">
                            <p className="font-medium">{action.type}</p>
                            <p className="text-sm">
                              {action.done}/{action.target}
                            </p>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5">
                            <div
                              className="h-2.5 rounded-full"
                              style={{
                                width: `${action.percentage}%`,
                                backgroundColor: COLORS[index % COLORS.length],
                              }}
                            ></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Actions Tab */}
              {activeTab === "actions" && (
                <div>
                  {/* Action completion status */}
                  <div className="bg-white rounded-lg shadow p-4 mb-4">
                    <h3 className="text-md font-semibold mb-3">
                      Action Status
                    </h3>

                    {reportData[0]?.actions.map((action, index) => {
                      const percentage =
                        action.target > 0
                          ? Math.round((action.done / action.target) * 100)
                          : 0;
                      let statusText, statusColor;

                      if (percentage >= 100) {
                        statusText = "Completed";
                        statusColor = "bg-green-100 text-green-800";
                      } else if (percentage >= 75) {
                        statusText = "On Track";
                        statusColor = "bg-blue-100 text-blue-800";
                      } else if (percentage >= 50) {
                        statusText = "In Progress";
                        statusColor = "bg-yellow-100 text-yellow-800";
                      } else {
                        statusText = "Needs Attention";
                        statusColor = "bg-red-100 text-red-800";
                      }

                      return (
                        <div
                          key={action.type}
                          className="mb-4 border-b pb-4 last:border-b-0 last:pb-0"
                        >
                          <div className="flex justify-between items-center mb-2">
                            <div>
                              <p className="font-medium">{action.type}</p>
                              <span
                                className={`text-xs px-2 py-1 rounded-full ${statusColor}`}
                              >
                                {statusText}
                              </span>
                            </div>
                            <div className="text-right">
                              <p className="text-2xl font-bold">
                                {action.done}
                              </p>
                              <p className="text-xs text-gray-500">
                                out of {action.target}
                              </p>
                            </div>
                          </div>

                          <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                            <div
                              className="h-2.5 rounded-full"
                              style={{
                                width: `${Math.min(percentage, 100)}%`,
                                backgroundColor: COLORS[index % COLORS.length],
                              }}
                            ></div>
                          </div>

                          <div className="flex justify-between mt-1">
                            <p className="text-xs text-gray-500">Progress</p>
                            <p className="text-xs font-medium">{percentage}%</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {activeTab === "kpi" && (
                <>
                <KpiDetailsComponent startDate={startDate} endDate={endDate}></KpiDetailsComponent>
                </>
              )}

              {/* Bottom info */}
              <div className="text-xs text-gray-500 text-center mt-6 px-4">
                Last updated: {new Date().toLocaleString()}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default BdmDashboardComponent;
